module.exports = __webpack_public_path__ + "img/schedule.b2333cc4.svg";